export interface CounterInterface {
  counterRef:any;
  ms: number;
  isAutoStart: boolean;
  callback: string;
}
export const enum GUARDS {
  IS_AUTO_START = 'isAutoStart',
}
export const enum STATES {
  IDLE = 'idle',
  COUNTING = 'counting',
  PAUSED = 'paused',
}
export const enum ACTIONS {
  TICK = 'tick',
  INIT_OBSERVER = 'initObserver',
}
export const enum EVENTS {
  TICK = 'TICK',
  START = 'START',
  PAUSE = 'PAUSE',
}
